<template>
  <div class="mt-4">
    <div class="row">
      <div class="offset-sm-9 col-sm-3">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            v-model="globalSearch"
            @input="setData()"
          />
          <label for="sizeOptions" class="input-group-text"
            ><font-awesome-icon
              class="my-auto"
              :icon="['fas', 'magnifying-glass']"
          /></label>
        </div>
      </div>
    </div>
  </div>
  <div
    :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3`"
  >
    <table :class="`table table-${getColorMode.background}`">
      <thead>
        <tr>
          <th
            v-for="(value, key) in columns"
            v-bind:key="`table-column-${key}`"
          >
            {{ value.text }}
          </th>
          <th>Acción</th>
        </tr>
        <tr v-if="1 == 0">
          <th
            v-for="(value, key) in columns"
            v-bind:key="`table-filter-column-${key}`"
          >
            <input
              type="text"
              :name="value.name"
              class="form-control"
              autocomplete="off"
            />
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="rows.length > 0">
        <tr
          v-for="(row, keyRow) in rows"
          v-bind:key="`table-inner-row-${keyRow}`"
        >
          <td
            v-for="(column, keyColumn) in columns"
            v-bind:key="`table-column-${keyColumn}`"
          >
            {{ row[column.name] }}
          </td>
          <td>
            <input
              type="checkbox"
              :id="'read-checkbox-' + row['id']"
              :ref="'read-checkbox-' + row['id']"
              @change="updateRolePermissions(row['id'], 'read')"
              :checked="row['has_permission_by_role'].read"
            />
            <label :for="'read-checkbox-' + row['id']">
              <Popper
                class="btn btn-sm btn-info m-0 mx-2 px-3 border-0"
                content="Permisos de lectura"
                placement="top"
                hover
                arrow
                offsetDistance="35"
              >
                <font-awesome-icon :icon="['fal', 'eye']" />
              </Popper>
            </label>
            <input
              type="checkbox"
              :id="'change-checkbox-' + row['id']"
              :ref="'change-checkbox-' + row['id']"
              @change="updateRolePermissions(row['id'], 'change')"
              :checked="row['has_permission_by_role'].change"
            />
            <label :for="'change-checkbox-' + row['id']">
              <Popper
                class="btn btn-sm btn-danger m-0 mx-2 px-3 border-0"
                content="Permisos de modificación"
                placement="top"
                hover
                arrow
                offsetDistance="35"
              >
                <font-awesome-icon :icon="['fas', 'pen-to-square']" />
              </Popper>
            </label>
            <input
              type="checkbox"
              :id="'write-checkbox-' + row['id']"
              :ref="'write-checkbox-' + row['id']"
              @change="updateRolePermissions(row['id'], 'write')"
              :checked="row['has_permission_by_role'].write"
            />
            <label :for="'write-checkbox-' + row['id']">
              <Popper
                class="btn btn-sm btn-warning m-0 mx-2 px-3 border-0"
                content="Permisos de escritura"
                placement="top"
                hover
                arrow
                offsetDistance="35"
              >
                <font-awesome-icon :icon="['fas', 'plus']" />
              </Popper>
            </label>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="text-center py-5" :colspan="columns.length + 1">
            <span v-if="loading">Buscando...</span>
            <span v-else>No existen datos disponibles</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-sm-6 d-flex justify-content-start my-auto">
      <div>
        <span class="items-per-page-text mb-0">Items por página:</span>
        <select
          id="sizeOptions"
          v-model="size"
          class="border-secondary mx-2"
          aria-label="Default select example"
          @change="changeSize()"
        >
          <option
            v-for="(value, key) in sizeOptions"
            v-bind:key="`size-select-${key}`"
          >
            {{ value }}
          </option>
        </select>
      </div>
      <p class="table-entries-text mb-0 text-left">
        {{ calcSize }} registros de {{ total }}
      </p>
    </div>
    <div class="col-sm-6">
      <nav aria-label="Paginación">
        <ul class="pagination justify-content-end">
          <span class="mx-4 my-auto items-per-page-text"
            >Página {{ page }} de {{ lastPage }}</span
          >
          <template v-if="page > 1">
            <li class="page-item">
              <a class="page-link" href="javascript:;" @click="page = 1"
                ><font-awesome-icon :icon="['fal', 'chevrons-left']"
              /></a>
            </li>
            <li class="page-item" aria-current="page">
              <a href="javascript:;" class="page-link" @click="page = page - 1"
                ><font-awesome-icon :icon="['fal', 'chevron-left']"
              /></a>
            </li>
          </template>
          <template v-else>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevrons-left']"
              /></a>
            </li>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevron-left']"
              /></a>
            </li>
          </template>
          <li class="page-item active" aria-current="page">
            <span class="page-link">{{ page }}</span>
          </li>
          <template v-if="page < lastPage">
            <li class="page-item" aria-current="page">
              <a href="javascript:;" class="page-link" @click="page = page + 1"
                ><font-awesome-icon :icon="['fal', 'chevron-right']"
              /></a>
            </li>
            <li class="page-item">
              <a class="page-link" href="javascript:;" @click="page = lastPage"
                ><font-awesome-icon :icon="['fal', 'chevrons-right']"
              /></a>
            </li>
          </template>
          <template v-else>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevron-right']"
              /></a>
            </li>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevrons-right']"
              /></a>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "dataTable",
  props: {
    url: { default: "" },
    editUrl: { default: "" },
    sizeOptions: { type: Array, default: () => [10, 50, 100] },
    roleId: { default: null },
    projectId: { default: null },
  },
  data() {
    return {
      rows: [],
      columns: [],
      page: 1,
      size: this.sizeOptions[0],
      total: 0,
      globalSearch: "",
      loading: false,
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    changeSize() {
      if (this.page == 1) this.setData();
      this.page = 1;
    },
    async setData() {
      let app = this;
      this.rows = [];
      this.loading = true;
      this.axios
        .get(
          `${this.url}?size=${this.size}&page=${this.page}&search=${this.globalSearch}&role_id=${this.roleId}`
        )
        .then((result) => {
          app.rows = result.data.body.data;
          app.total = result.data.body.total;
          app.columns = result.data.body.columns;
          app.loading = false;
        })
        .catch((error) => {
          app.loading = false;
          console.log(error);
        });
    },
    async updateRolePermissions(folderId, type) {
      let app = this;
      this.loading = true;
      let checkboxSelected = `${type}-checkbox-${folderId}`;
      this.axios
        .post(`roles/update_role_permission`, {
          folder_id: folderId,
          role_id: app.roleId,
          project_id: app.projectId,
          type: type,
          value: this.$refs[checkboxSelected][0].checked,
        })
        .then(() => {
          this.setData();
          app.loading = false;
        })
        .catch((error) => {
          app.loading = false;
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    lastPage() {
      return Math.ceil(parseFloat(this.total) / parseFloat(this.size));
    },
    calcSize() {
      return this.total < this.size ? this.total : this.size;
    },
  },
  watch: {
    page: {
      handler: function () {
        this.setData();
      },
    },
  },
};
</script>
